import React, {Component} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {getCities} from 'common/actions/general/getCities';
import {getStreets} from 'common/actions/general/getStreets';

function withCitiesAndStreets(WrappedComponent) {
  return class extends Component {
    componentDidMount() {
      this.updateCities();
    }

    updateCities = () => {
      const {cities, getCities} = this.props;
      if (!Boolean(cities.list) || cities.list.length === 0) {
        getCities();
      }
    }

    updateStreets = cityID => this.props.getStreets(cityID);

    getOptions = () => {
      const {cities, streets} = this.props;
      return {
        cities: (cities) ? cities.list : [],
        streets: (streets) ? streets.list : [],
      }
    };

    render() {

      return <WrappedComponent {...this.props} {...this.getOptions()} updateStreets={this.updateStreets}/>;
    }
  };
}

const mapStateToProps = ({
                           options: {cities, streets}
                         }) => {
  return {cities, streets};
};

export default compose(
  connect(
    mapStateToProps,
    {getCities, getStreets}
  ),
  withCitiesAndStreets
);
